<div class="card card-custom">
    <!-- Header -->
    <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Lista proiecte</span>
            <!--            <span class="text-muted mt-3 font-weight-bold font-size-sm"-->
            <!--            >More than 400+ new members</span-->
            <!--            >-->
        </h3>
        <div class="card-toolbar">
            <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
               routerLink="/sistemerp/proiecte/adauga-proiect">
                Adauga proiect <span class="fa fa-plus-circle"></span>
            </a>
        </div>
    </div>
    <!--begin::Body-->
    <div class="card-body py-0">

        <form #searchForm="ngForm" class="filterForm">
            <div class="row filters-section align-items-end">

                <div class="col-md-3  form-group">
                    <label>Nume proiect</label>
                    <input type="text" [(ngModel)]="projectName"
                           class="form-control"/>
                </div>
                <div class="col-md-3  form-group">
                    <label>Numar proiect</label>
                    <input type="text" [(ngModel)]="projectNumber"
                           class="form-control"/>
                </div>
                <div class="col-md-3  form-group">
                    <label>Nume client</label>
                    <ng-select2 [(ngModel)]="clientName"
                                *ngIf="dataLoaded"
                                [data]=clientsNameArray
                                [options]="singleSelect"
                                [allowClear]="true"
                                class="select2-input"
                                name="companyName">
                    </ng-select2>
                </div>
                <div class="col-md-2  form-group">
                    <label>Status</label>
                    <select [(ngModel)]="projectStatus" class="form-control">
                        <option value="">--Alege o optiune--</option>
                        <option value="Nou">Nou</option>
                        <option value="In lucru">In lucru</option>
                        <option value="Propuneri candidati">Propuneri candidati</option>
                        <option value="Interviuri client">Interviuri client</option>
                        <option value="Oferta angajare">Oferta angajare</option>
                        <option value="Finalizat">Finalizat</option>
                        <option value="Inlocuire in garantie">Inlocuire in garantie</option>
                        <option value="Alte etape">Alte etape</option>
                    </select>
                </div>
                <div class="col-md-1 text-right  form-group">
                    <button class="btn btn-light-primary px-3 font-weight-bold"
                            type="button"
                            (click)="getProjects();">
                        <span class="fa fa-search"></span>
                    </button>
                </div>
            </div>
        </form>

        <hr>
        <div>
            <label class="mb-0">Nr. total de rezultate: {{totalElements}}</label>
        </div>
        <hr>
        <div class="row mt-5 mb-5 just">
            <div class="col-md-3">
                <div class="d-flex align-items-center">
                    <label class="mr-3 mb-0">Rezultate: </label>
                    <select (change)="onSizeChange($event)" class="form-control">
                        <option *ngFor="let size of pageSizes" [ngValue]="size">
                            {{ size }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-6 offset-3">
                <div class="d-flex align-items-center justify-content-end">
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="mr-3 mb-0">Sortare: </label>
                        <select (change)="onSortChange($event)" class="form-control">
                            <option [ngValue]="undefined"> -- Alege --</option>
                            <option *ngFor="let item of sortingValues" value="{{item.value}}">{{item.name}}</option>

                        </select>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="mr-3 mb-0">Ordonare: </label>
                        <select (change)="onOrderChange($event)" class="form-control">
                            <option [ngValue]="undefined"> -- Alege --</option>
                            <option value="asc">Ascendent</option>
                            <option value="desc">Descendent</option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
        <hr>

        <app-form-message [success]="formResponse" *ngIf="formSent"
                          [customSuccessMessage]="'Jobul a fost creat cu informatiile din proiect! Vei fi redirectionat in scurt timp.'"></app-form-message>

        <ngb-alert #selfClosingAlert *ngIf="successMessage" type="success" (closed)="successMessage = ''"
                   xmlns="http://www.w3.org/1999/html">{{ successMessage }}
        </ngb-alert>

        <ngb-alert #selfClosingError *ngIf="errorMessage" type="danger" (closed)="errorMessage = ''">{{ errorMessage }}
        </ngb-alert>

        <!--begin::Table-->
        <div class="table-responsive">
            <table
                    class="table table-head-custom table-vertical-center"
                    id="kt_advance_table_widget_1"
            >
                <thead>
                <tr class="text-left">
                    <th class="pr-0 pl-0" style="min-width: 100px">Status</th>
                    <th style="min-width: 150px">Număr proiect</th>
                    <th style="min-width: 150px">Nume proiect</th>
                    <th style="min-width: 180px">Manager proiect ABJ</th>
                    <th style="min-width: 150px">Client</th>
                    <th style="min-width: 150px">Companie Angajatoare</th>
                    <th style="min-width: 150px">Denumire post</th>
                    <th style="min-width: 150px">Persoana contact angajator</th>
                    <th style="min-width: 150px">Numar posturi</th>
                    <th style="min-width: 150px">Locatie post</th>
                    <th style="min-width: 150px">Nivel post</th>
                    <th style="min-width: 150px">Tip post</th>
                    <th style="min-width: 150px">Tip contract</th>
                    <th style="min-width: 150px">Disponibilitate post</th>
                    <th style="min-width: 150px">Dificultate proiect</th>
                    <th style="min-width: 150px">Vizibilitate proiect(X)</th>
                    <th style="min-width: 150px">Durata de implementare</th>
                    <th style="min-width: 150px">Garantia solicitata(X)</th>
                    <th style="min-width: 150px">Recrutori necesari</th>
                    <th style="min-width: 150px">Cerinte speciale(X)</th>
                    <th class="pr-0 text-right" style="min-width: 200px">Actiuni</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let project of projectsData">
                    <ng-template #contentStatus let-c="close" let-d="dismiss">
                        <div class="modal-header">
                            <h4 class="modal-title">Schimbare status - {{project.name}}</h4>
                            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                Alege statusul:
                            </p>

                            <select [(ngModel)]="newProjectStatus" name="status_{{project.id}}"
                                    #statusController="ngModel" class="form-control" required>
                                <option [ngValue]="undefined"> -- Selecteaza un status --</option>
                                <option value="Nou">Nou</option>
                                <option value="In lucru">In lucru</option>
                                <option value="Propuneri candidati">Propuneri candidati</option>
                                <option value="Interviuri client">Interviuri client</option>
                                <option value="Oferta angajare">Oferta angajare</option>
                                <option value="Finalizat">Finalizat</option>
                                <option value="Inlocuire in garantie">Inlocuire in garantie</option>
                                <option value="Alte etape">Alte etape</option>
                            </select>
                            <div class="error-msg" *ngIf="!statusController.valid && (statusController.touched)">Acest
                                camp este obligatoriu!
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" (click)="c('Close click')">Anulare</button>
                            <button type="button" class="btn btn-primary"
                                    (click)="changeProjectStatus(project.id, newProjectStatus); c('Close click')"
                                    [disabled]="!statusController.valid">Schimbare status
                            </button>
                        </div>
                    </ng-template>


                    <td class="pl-0">
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.status}}</p>
                    </td>
                    <td class="pl-0">
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.projectNumber}}</p>
                    </td>
                    <td class="pl-0">
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.name}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.projectManagerName}} {{project.projectManagerLastName}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.clientName}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.employingCompany}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.jobName}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.managerName}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.numberAvailableJobs}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.jobCities}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.levelJob}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.jobType}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.contractType}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.jobAvailability | enumTransform }}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.levelDifficulty}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">X</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.implementationDuration}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">X</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">{{project.recruiters.length}}</p>
                    </td>
                    <td>
                        <p class="text-dark-75 font-weight-bolder font-size-lg">X</p>
                    </td>
                    <td class="pr-0 text-right">
                        <a class="btn btn-icon btn-success btn-hover-primary btn-sm mr-3"
                           routerLink="/sistemerp/proiecte/vizualizare/{{project.id}}" ngbTooltip="Vezi"
                           placement="bottom">
                            <i class="icofont-eye-alt"></i>
                        </a>
                        <a class="btn btn-icon btn-info btn-hover-primary btn-sm mr-3"
                           routerLink="/sistemerp/proiecte/editare/{{project.id}}" ngbTooltip="Editeaza"
                           placement="bottom">
                            <i class="icofont-edit"></i>
                        </a>
                        <!--                        <a class="btn btn-icon btn-danger btn-hover-primary btn-sm">-->
                        <!--                            <i class="icofont-ui-rotation"></i>-->
                        <!--                        </a>-->
                        <a class="btn btn-icon btn-danger btn-hover-primary btn-sm mr-3" (click)="openSmall(contentStatus)"
                           ngbTooltip="Schimba status" placement="bottom">
                            <i class="icofont-ui-rotation"></i>
                        </a>

                        <a class="btn btn-icon btn-duplicate btn-hover-primary btn-sm"
                                title="Creeaza Job" (click)="createJobAfterProject(project.id)">
                            <i class="icofont-copy-invert"></i>
                        </a>

                    </td>

                </tr>
                </tbody>
            </table>

        </div>
        <!--end::Table-->

        <div class="col-md-12 mt-5">
            <ngb-pagination class="d-flex justify-content-center"
                            [(page)]="page"
                            [pageSize]="size"
                            [maxSize]="5"
                            [collectionSize]="totalElements"
                            (pageChange)="onPageChange(page)"
            ></ngb-pagination>
        </div>
    </div>
    <!--end::Body-->
</div>
